import {
  ActionLabel,
  Card,
  CardContent,
  CardLink,
  Eyebrow,
  Grid,
  Heading,
  Stack,
  Text,
} from "@generalapplications/ui";

import { PageSection } from "@/app/common/components/composite/layout/PageSection";
import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { homePage } from "@/content/home";
import { routes, sectionIds } from "@/app/common/functions/routes/routes";
import { formatText } from "@/app/common/functions/format/formatText";

/** The four capabilities, each a card into its own page. */
export function Capabilities() {
  return (
    <PageSection
      id={sectionIds.capabilities}
      title={homePage.capabilities.headline}
      subheading={homePage.capabilities.copy}
    >
      <RevealGroup>
        <Grid columns={{ base: 1, md: 2, lg: 3 }} gap="xl">
          {homePage.capabilities.cards.map((card) => (
            <RevealItem key={card.title}>
              <Card radius="xxl" padding="lg" height="full" interactive>
                <CardContent grow gap="lg">
                  <Stack gap="sm">
                    <Eyebrow tone="section">{card.title.slice(0, 2)}</Eyebrow>
                    <Heading level={3} size="lg">
                      {formatText(card.title)}
                    </Heading>
                    <Text leading="relaxed">
                      {formatText(card.description)}
                    </Text>
                  </Stack>
                  <CardLink href={routes.capabilities.detail(card.slug)}>
                    <ActionLabel>{card.cta}</ActionLabel>
                  </CardLink>
                </CardContent>
              </Card>
            </RevealItem>
          ))}
        </Grid>
      </RevealGroup>
    </PageSection>
  );
}
